var map = {
	"./de/group-logo.png": "bC0p",
	"./en/group-logo.png": "BTQa",
	"./es/group-logo.png": "u09Y",
	"./fr/group-logo.png": "ykYv",
	"./ja/group-logo.png": "UXWb",
	"./ko/group-logo.png": "jdGJ",
	"./pt/group-logo.png": "ARWC",
	"./ru/group-logo.png": "UqS5",
	"./tc/group-logo.png": "6TUz",
	"./th/group-logo.png": "MIOY"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfgJ";